(() => {
  const selector = '.flickity-slider > [aria-selected]';

  const removeInvalidSelectionState = (root) => {
    if (!(root instanceof Element)) return;

    if (root.matches(selector)) {
      root.removeAttribute('aria-selected');
    }

    root.querySelectorAll(selector).forEach((cell) => {
      cell.removeAttribute('aria-selected');
    });

    const headings = root.matches('h3.complementary-products__title')
      ? [root]
      : root.querySelectorAll('h3.complementary-products__title');

    headings.forEach((heading) => {
      const replacement = document.createElement('h2');
      replacement.className = heading.className;
      replacement.innerHTML = heading.innerHTML;
      heading.replaceWith(replacement);
    });

    const productHeadings = root.matches('h4.complementary-product__name')
      ? [root]
      : root.querySelectorAll('h4.complementary-product__name');

    productHeadings.forEach((heading) => {
      const replacement = document.createElement('h3');
      replacement.className = heading.className;
      replacement.innerHTML = heading.innerHTML;
      heading.replaceWith(replacement);
    });
  };

  const initialise = () => {
    removeInvalidSelectionState(document.body);

    const observer = new MutationObserver((records) => {
      records.forEach((record) => {
        if (record.type === 'attributes') {
          removeInvalidSelectionState(record.target);
          return;
        }

        record.addedNodes.forEach(removeInvalidSelectionState);
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['aria-selected'],
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
